import React from "react";
import styles from "./Plans.module.scss"
import Image from "next/image";

const Crad = (props) => {
  const { price, phase, Percentage, tokens , image } = props;
  return (
    <div className={styles.card}>
      <div className={styles.content}>
        <h1 className={styles.titles}>{phase}</h1>
        <h3 className={styles.titelPrice}>Internal price</h3>
        <h4 className={styles.price}>{price}</h4>

        <div className={styles.Percentage}>
          <h3 className={styles.titlePer}>Supply Percentage</h3>
          <h4 className={styles.pricePercentage}>{Percentage}</h4>

          <h3 className={styles.titlePer}>Supply Percentage</h3>
          <h4 className={styles.pricePercentage}>{tokens}</h4>
        </div>

        <Image alt="plan" src={image} width={80} height={44} className={styles.image} />
      </div>
    </div>
  )
};

export default Crad;
